import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '@/contexts/LanguageContext';
import { MARKETING_FAQ_SECTIONS } from '@/lib/marketing/faqStructure';

/** FAQPage structured data for rich results (Google). */
export function FaqJsonLd() {
  const { t } = useLanguage();

  const jsonLd = useMemo(() => {
    const mainEntity = MARKETING_FAQ_SECTIONS.flatMap((section) =>
      section.items.map((item) => ({
        '@type': 'Question',
        name: t(item.qKey),
        acceptedAnswer: {
          '@type': 'Answer',
          text: t(item.aKey),
        },
      })),
    );
    return {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity,
    };
  }, [t]);

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
